import React, { useState } from 'react'
import './ProductStyle.css'
import ProductCard from '../../Components/Card/ProductCard'
import { NavBar } from '../../Components/Navigation/NavBar'
import { Footer } from '../../Components/Footer/Footer'
import home2 from '../../Assets/home2.png'
export const Products = () => {
  const [posts] = useState([])


  posts.push({productId:"attendanceplatform",productName:"Attendance Platform",productIcon:home2})
  return (
    
    <div style={{ backgroundColor: 'white' }}>
      <NavBar />
      <h1 className=" text-center text-dark p-3">Products</h1>

      {posts.map((post) => {
        return (
          <div key={post.id}>
            <ProductCard
             productId={post.productId}
             productIcon={post.productIcon}
             productName={post.productName}
            />
          </div>
        )
      })}
      <Footer/>
    </div>
  )
}
